import { render, staticRenderFns } from "./videoTutorialPage.vue?vue&type=template&id=782906ae&scoped=true"
import script from "./videoTutorialPage.vue?vue&type=script&lang=js"
export * from "./videoTutorialPage.vue?vue&type=script&lang=js"
import style0 from "./videoTutorialPage.vue?vue&type=style&index=0&id=782906ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782906ae",
  null
  
)

export default component.exports